import React from 'react'
import Button from 'react-bootstrap/Button'
import './styles.scss'

function Download() {
  return (
    <div className='container download'>
      <div className='row'>
        <div className='col-12'>
          <h1 className='text-center'>Descargas disponibles</h1>
        </div>
        <div className='col-12'>
          <div className='text-center'>
            <h2>Android</h2>
            <a href='https://play.google.com/store/apps/details?id=com.rancagua.digital&hl=es_CL&gl=US'>
              <img
                src='/assets/googleplay.svg'
                className='img-fluid'
                alt='Google Play'
              />
            </a>
          </div>
        </div>
        <div className='col-12'>
          <div className='text-center'>
            <h2>iOS</h2>
            <a href='https://apps.apple.com/cl/app/rancagua-digital/id1448600402'>
              <img
                src='/assets/appstore.svg'
                className='img-fluid'
                alt='App Store'
              />
            </a>
          </div>
        </div>
        <div className='col-12'>
          <div className='text-center'>
            <h2>Web (beta)</h2>
            <a href='https://rancagua.digital'>
              <img
                src='/assets/webversion.svg'
                className='img-fluid'
                alt='App Store'
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Download
